const SHIPPING_METHOD_KEY = "fulling_checkout_shipping_method_id_v1";

export function readPreferredShippingMethodId(): string {
  if (typeof window === "undefined") return "";
  try {
    return window.localStorage.getItem(SHIPPING_METHOD_KEY) || "";
  } catch {
    return "";
  }
}

export function savePreferredShippingMethodId(shippingMethodId: string): void {
  if (typeof window === "undefined") return;
  try {
    if (shippingMethodId) {
      window.localStorage.setItem(SHIPPING_METHOD_KEY, shippingMethodId);
    } else {
      window.localStorage.removeItem(SHIPPING_METHOD_KEY);
    }
  } catch {
    // Preference persistence is optional; checkout still validates through the API.
  }
}
